import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import { MenuItem, Message, MessageService } from "primeng/api";
import { Country, PhoneCountry } from "src/app/model/country";
import { DocTypeEnum } from "src/app/model/enum/doc-type";
import { Account } from "src/app/model/form/account";
import { ACCOUNT_1 } from "src/app/model/mockup/account-mockup";
import { COUNTRY_LIST } from "src/app/model/mockup/country-mockup";
import { CustomValidator } from "src/shared/custom-validator";
import { AccountService } from "../../../service/account.service";
import { enviroment } from "src/environments/environment";
import { LANGUAGE_LIST } from "src/app/model/mockup/language-mockup";
import { Language } from "src/app/model/language";
import { CountryService } from "src/app/service/country.service";
import { ReasonService } from "src/app/service/reason.service";
import { Reason } from "src/app/model/reason";
import { DocType } from "src/app/model/doc-type";
import { DecimalPipe, Location } from "@angular/common";
import { ConfirmationService } from "primeng/api";
import { cpf, cnpj } from "cpf-cnpj-validator";
import { ActivatedRoute } from "@angular/router";
import { Table } from "primeng/table";
import { TrashService } from "src/app/service/trash.service";
import { Trash } from "src/app/model/trash";
import { TrashRestoreRequest } from "src/app/model/request/trashRestore-request";
import { combineLatest, forkJoin, lastValueFrom } from "rxjs";
import { ChangeDetectorRef } from "@angular/core";
import { AuthService } from "src/app/service/auth.service";
import { AdminService } from "src/app/service/admin.service";
import { StorageUsedResponse } from "src/app/model/response/storage-used-response";
import { TunerService } from "src/app/service/tuner.service";
import { PlanFeatureService } from "src/app/service/plan-feature.service";
import { UserTuner, TunerPublic } from "src/app/model/response/tuner-response";
import { HttpErrorResponse } from "@angular/common/http";
import { AiService } from "src/app/service/ai.service";
import {
  AiFreeTank,
  AiUsageResponse,
  AiUsageHistoryItem,
  FreeTankState,
  canBuyExtraTokens,
  isPaidPlan,
  shouldShowReserveRule,
  freeTankFillPercent,
  freeTankMinutesToRefill,
  freeTankRemainingDisplay,
  freeTankState,
  historyCreditOrigin,
  isFreeTankInUse,
} from "src/app/model/response/ai-response";
import { SocialService } from "src/app/service/social.service";
import { checkUpload, uploadRejectI18n, UploadCheck } from "src/app/shared/upload/upload-policy";

@Component({
  selector: "app-account",
  templateUrl: "./account.component.html",
  styleUrl: "./account.component.css",
  // DecimalPipe: formata a % do tanque no histórico seguindo o mesmo locale dos pipes do
  // template, em vez de um toFixed() com separador fixo.
  providers: [DecimalPipe],
})
export class AccountComponent implements OnInit, OnDestroy {
  @ViewChild(Table) dtTrash!: Table;

  public form!: FormGroup;
  public changePasswordForm!: FormGroup;

  account!: Account;
  accountDB!: Account;
  changePassword!: Account;
  userId: string | null = null;
  items: MenuItem[] | undefined;
  activeItem: MenuItem | undefined;
  itensTrash: Trash[] = [];
  parametroId: string = "data";
  loadingTrash: boolean = false;
  selectedDocumento: any = null;
  searchValue: string = "";
  item: any = {};
  countryOptions: Country[] = [];
  docType: DocType | null = null;
  urlDashboard: string = "";
  language: Language;
  lastLanguage: Language;
  languageOptions: Language[] = [];
  inactiveReasonOptions: Reason[] = [];
  isBrasil: boolean = false;
  isBrasilDate: boolean = false;
  showBirthDate: boolean = true;
  placeHolderName: string = "";
  minDate: Date | undefined;
  maxDate: Date | undefined;
  beforeInactive: boolean = true;
  submitBtnLoading: boolean = false;
  backBtnLoading: boolean = false;
  countries: PhoneCountry[] = [];
  currentMask: string = "";
  selectedCountry: any;
  isLoadingAccount: boolean = false;
  currentLocale: string = "pt-br";
  accessToken: string | null = null;
  mfaEnabled: boolean = false;
  dashboardUrl: string = "";

  showChagePasswordModal: boolean = false;
  messagesPassword: Message[] = [];
  oldPassword: string = "";
  newPassword: string = "";

  storageData: { label: string; value: number; color: string; icon: string }[] = [
    { label: '', value: 0, color: '#e74c3c', icon: 'pi-file' },
    { label: '', value: 0, color: '#e67e22', icon: 'pi-file' },
    { label: '', value: 0, color: '#f1c40f', icon: 'pi-file' },
  ]

  storageUsed?: StorageUsedResponse | null;
  chartStorageUsedData: any;
  chartStorageUsedOptions: any;
  totalStorage = 0;
  usedStorage = 0;
  displayStorageUsedDialog: boolean = false;
  planInformation: any = null;
  portalLoading: boolean = false;
  showUpgradeModal: boolean = false;
  showBuyTokensModal: boolean = false;

  /**
   * Deep link dos apps (Vision: from=vision; mobile: from=app): ?buy=1 abre a modal de
   * compra de pacotes direto. A abertura é adiada até o aiUsage chegar — a modal usa
   * currentCreditsTotal para calcular o saldo-alvo do polling da tela de sucesso, e com
   * ele nulo o alvo sairia só como tokenAmount, fazendo a tela de sucesso declarar
   * sucesso na primeira tentativa sem esperar o webhook.
   */
  private pendingBuyTokens: boolean = false;

  /**
   * Deep link ?buy=2 abre a modal de planos, para qualquer plano (Free → pago e pago →
   * outro pago). Adiada até o planInformation chegar: a modal destaca o plano atual e o
   * estado da assinatura, e sem isso abriria como se o usuário não tivesse plano.
   */
  private pendingPlans: boolean = false;

  accountType: 'user' | 'tuner' | null = null;
  tunerProfileId: string | null = null;
  /** OCULTA a seção "Meu Tuner" da UI (esconder sem remover; reativar: mudar para true). */
  /**
   * Seção "Meu Tuner": permite escolher um tuner DEPOIS de já ter plano, sem
   * depender do checkout. O cashback passa a contar para esse tuner na próxima
   * fatura — o backend resolve a afiliação no momento do invoice, não na assinatura.
   */
  showTunerSection = true;
  becomeTunerLoading: boolean = false;
  userTuner: UserTuner | null = null;
  userTunerLoading: boolean = false;
  removeTunerLoading: boolean = false;

  // Affiliate tuner flow
  showAffiliatePanel: boolean = false;
  affiliateTuners: TunerPublic[] = [];
  affiliateTunersLoading: boolean = false;
  selectedAffiliateTunerId: string | null = null;
  affiliateMode: 'list' | 'code' = 'list';
  affiliateInviteCode: string = '';
  affiliateCodeValidating: boolean = false;
  affiliateCodeError: string = '';
  validatedAffiliateTuner: TunerPublic | null = null;
  affiliateLoading: boolean = false;
  private pendingTunnerCode: string | null = null;

  // AI consumption
  aiUsage: AiUsageResponse | null = null;
  aiUsageLoading: boolean = false;
  aiUsageError: boolean = false;
  aiHistory: AiUsageHistoryItem[] = [];
  aiHistoryLoading: boolean = false;
  aiHistoryPage: number = 1;
  aiHistoryPageSize: number = 20;
  aiHistoryTotalCount: number = 0;
  /** Histórico começa recolhido; expande no clique e só então busca os dados. */
  aiHistoryLoaded: boolean = false;
  /**
   * Tamanho do tanque em créditos, vindo do próprio /AI/usage/history. Pode faltar em
   * ambiente/plano antigo — nesse caso a coluna volta a mostrar créditos.
   */
  aiHistoryTankSize: number | null = null;

  // Foto de perfil (avatar social)
  avatarUrl: string | null = null;
  avatarUploading = false;
  avatarCropperVisible = false;
  avatarFileToCrop: File | null = null;

  /** Iniciais para o círculo do avatar quando não há foto (até duas letras: primeiro e último nome). */
  get avatarInitials(): string {
    const name: string = (this.form?.get('name')?.value ?? '').trim();
    if (!name) { return ''; }
    const parts = name.split(/\s+/);
    const first = parts[0][0] ?? '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] ?? '' : '';
    return (first + last).toUpperCase();
  }

  /** Toast padrão de upload rejeitado (tipo/tamanho) usando a política central. */
  private notifyUploadRejected(chk: UploadCheck): void {
    const m = uploadRejectI18n(chk);
    this.messageService.add({
      severity: 'error',
      summary: this.translocoService.translate(m.summaryKey),
      detail: this.translocoService.translate(m.detailKey, { '0': m.param }),
    });
  }

  constructor(
    private formBuilder: FormBuilder,
    private formBuilderPass: FormBuilder,
    private router: Router,
    private titleService: Title,
    private translocoService: TranslocoService,
    private messageService: MessageService,
    private accountService: AccountService,
    private countryService: CountryService,
    private reasonService: ReasonService,
    private confirmationService: ConfirmationService,
    private trashService: TrashService,
    private location: Location,
    private route: ActivatedRoute,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private adminService: AdminService,
    private tunerService: TunerService,
    private aiService: AiService,
    private socialService: SocialService,
    private planFeatureService: PlanFeatureService,
    private decimalPipe: DecimalPipe
  ) {
    this.languageOptions = LANGUAGE_LIST as [];

    this.language = this.languageOptions[0];
    this.lastLanguage = this.languageOptions[0];
    this.dashboardUrl = "/my-garage";
  }

  /** Valida a imagem escolhida e abre o diálogo de recorte; o upload real ocorre em onAvatarCropped. */
  onAvatarSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file || !this.userId) return;

    const chk = checkUpload(file, 'avatar');
    if (!chk.ok) {
      input.value = '';
      this.notifyUploadRejected(chk);
      return;
    }

    input.value = ''; // permite re-selecionar o mesmo arquivo depois
    this.avatarFileToCrop = file;
    this.avatarCropperVisible = true;
  }

  /** Sobe a foto já recortada (1:1) vinda do diálogo de ajuste. */
  onAvatarCropped(file: File): void {
    if (!this.userId) return;
    this.avatarUploading = true;
    this.socialService.changeAvatar(this.userId, file).subscribe({
      next: () => {
        // Exibe o blob local (evita a race de propagação do S3); revoga o anterior.
        if (this.avatarUrl?.startsWith('blob:')) {
          URL.revokeObjectURL(this.avatarUrl);
        }
        this.avatarUrl = URL.createObjectURL(file);
        this.avatarUploading = false;
        this.messageService.add({ severity: 'success', summary: 'Avatar', detail: this.translocoService.translate('socialFeed.avatarUpdated') });
      },
      error: () => {
        this.avatarUploading = false;
        this.messageService.add({ severity: 'error', summary: 'Avatar', detail: this.translocoService.translate('socialFeed.avatarError') });
      },
    });
  }

  ngOnDestroy(): void {
    if (this.avatarUrl?.startsWith('blob:')) {
      URL.revokeObjectURL(this.avatarUrl);
    }
    this.stopReserveCountdown();
  }

  async ngOnInit() {
    this.pendingTunnerCode = this.route.snapshot.queryParamMap.get('tunnerCode');
    const buyParam = this.route.snapshot.queryParamMap.get('buy');
    this.pendingBuyTokens = buyParam === '1' || buyParam === 'true';
    this.pendingPlans = buyParam === '2';
    this.currentLocale = sessionStorage.getItem("language") || "pt-br";
    this.isLoadingAccount = true;
    this.account = new Account();
    // this.userId = sessionStorage.getItem("idUser");
    this.userId = this.authService.getUserInformations()
    this.createForm(this.account);
    this.createChangePasswordForm();
    this.openPendingChangePasswordModal();
    this.adaptForm();
    this.accessToken = sessionStorage.getItem("token");

    if (this.userId) {
      // Foto de perfil atual (404 = sem perfil social ainda → sem foto, mostra placeholder).
      this.socialService.getProfile(this.userId).subscribe({
        next: (p) => { this.avatarUrl = p.avatarUrl ?? null; },
        error: () => {},
      });
      this.accountService.getAccount(this.userId).subscribe((data) => {
        if (data.accessLevel == 2) {
        }
        this.planInformation = data.planInformation;
        this.planFeatureService.load(data.planInformation);
        this.tunerGateLoading = false;
        this.openPendingPlansModal();
        this.scrollToTunerSectionIfRequested();
        this.accountType = data.accountType ?? null;
        this.tunerProfileId = data.tunerProfileId ?? null;
        this.getUserStorageUsed(data.planInformation);
        this.loadUserTuner();
      });
    }

    if (enviroment.MOCKUP) {
      this.countryOptions = COUNTRY_LIST;
      this.account = ACCOUNT_1;
      this.createForm(this.account);
      this.createChangePasswordForm();
      this.adaptForm();
      this.updateMask();
    } else {
      try {
        const [countries, reasons] = await lastValueFrom(
          forkJoin([
            this.countryService.getAllCountry(),
            this.reasonService.getAllReason(),
          ])
        );
        this.countryOptions = CountryService.toCountryList(countries);
        this.countries = CountryService.toCountryList(countries);
        this.inactiveReasonOptions = ReasonService.toReasonList(reasons);

        if (this.userId) {
          const accountResponse = await lastValueFrom(
            this.accountService.getAccount(this.userId)
          );
          this.account = AccountService.toAccount(accountResponse);
          this.accountDB = { ...this.account };
          this.accountType = accountResponse.accountType ?? null;
          this.tunerProfileId = accountResponse.tunerProfileId ?? null;
          this.account.phoneCountry = this.countries.find(
            (c) => c.id === this.account.phoneCountry.id
          )!;

          this.createForm(this.account);
          this.createChangePasswordForm();
          this.adaptForm();
          this.updateMask();

          this.loadingTrash = true;
          const trashList = await lastValueFrom(
            this.trashService.getTrashList(this.userId)
          );
          this.itensTrash = Trash.fromArray(trashList);

          this.loadingTrash = false;
          this.isLoadingAccount = false;
        }
        if (this.accessToken) {
          let response = await this.authService.getUser(this.accessToken);
          if (response.userAttributes && response.userAttributes.length > 0) {
            let mfaAttr = response.userAttributes.find(
              (attr) => attr.name === "custom:mfa_enabled"
            );
            if (mfaAttr) {
              this.mfaEnabled = mfaAttr.value === "true" ? true : false;
            } else {
              this.mfaEnabled = false;
            }
          }
        }
      } catch (error) {
        this.isLoadingAccount = false;
        if (!this.countryOptions) this.countryOptions = [];
        if (!this.inactiveReasonOptions) this.inactiveReasonOptions = [];
        this.messageService.clear();
        this.messageService.add({
          key: "toastAccount",
          severity: "error",
          summary: this.translocoService.translate("user.trash.errorLoadTrash"),
        });
      }
    }

    this.changeLanguage();
    this.urlDashboard = "/my-garage";

    combineLatest([
      this.translocoService.selectTranslate("user.account.basicData"),
      this.translocoService.selectTranslate("user.account.trash"),
    ]).subscribe(([basicData, trash]) => {
      this.items = [
        { id: "data", label: basicData, icon: "pi pi-user", command: () => this.setActiveTab("data") },
        {
          id: "subscription",
          label: this.translocoService.translate("user.account.subscription"),
          icon: "pi pi-credit-card",
          command: () => this.setActiveTab("subscription"),
        },
        { id: "trash", label: trash, icon: "pi pi-trash", command: () => this.setActiveTab("trash") },
        {
          id: "ai",
          label: this.translocoService.translate("user.account.aiConsumption"),
          icon: "pi pi-bolt",
          command: () => this.setActiveTab("ai"),
        },
      ];
      // Itens são recriados a cada troca de idioma: o destaque segue a aba atual, não o primeiro item.
      this.syncActiveItem();
    });

    this.route.params.subscribe((params) => {
      this.parametroId = params["id"];
      this.setActiveTab(this.parametroId);
      if (this.pendingTunnerCode || this.showAffiliatePanel) {
        this.setActiveTab('subscription');
      }
    });
    setTimeout(() => {
      this.messageService.clear();
    }, 0);
  }

  /**
   * Rola até "Meu Tuner" quando o usuário chega pelo atalho do menu de perfil.
   * Chamado após a conta carregar — antes disso a seção ainda nem existe no DOM.
   */
  private scrollToTunerSectionIfRequested(): void {
    if (this.route.snapshot.fragment !== 'meu-tuner') return;
    setTimeout(() => {
      document.getElementById('meu-tuner')
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 0);
  }

  updateMask() {
    const selectedCountry = this.form.get("phoneCountry")?.value;
    const country = this.countries.find(
      (c) => c.code === selectedCountry?.code
    );

    if (country) {
      this.currentMask = country.mask;
      const phoneControl = this.form.get("phone");

      if (phoneControl) {
        const currentPhoneValue = phoneControl.value || "";
        const isValidForNewMask = new RegExp(
          this.currentMaskToRegex(country.mask)
        ).test(currentPhoneValue);
        phoneControl.updateValueAndValidity();
      }
    }
  }

  currentMaskToRegex(mask: string): string {
    return mask
      .replace(/9/g, "\\d")
      .replace(/\(/g, "\\(")
      .replace(/\)/g, "\\)")
      .replace(/\s/g, "\\s");
  }

  activeTab: string = "data";

  // ─── Invoices (recibos) ───────────────────────────────────────────────
  selectedInvoiceId: string | null = null;
  showInvoiceDetailModal: boolean = false;

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    this.syncActiveItem();
    if (tab !== 'ai') { return; }
    if (!this.aiUsage && !this.aiUsageLoading) {
      this.loadAiUsage();
    } else if (this.aiUsage) {
      // Aba reaberta com o consumo já em cache: não há load para aguardar.
      this.openPendingBuyTokensModal();
    }
    // O histórico fica sempre visível na aba; aiHistoryLoaded só vira true no sucesso, então uma falha volta a tentar.
    if (!this.aiHistoryLoaded && !this.aiHistoryLoading) {
      this.loadAiHistory();
    }
  }

  /** O p-tabMenu só sublinha o item que recebe em [activeItem]; ele tem de ser a mesma referência da lista. */
  private syncActiveItem(): void {
    const items = this.items ?? [];
    this.activeItem = items.find((item) => item.id === this.activeTab) ?? items[0];
  }

  /**
   * Consome o deep link ?buy=1 (uma vez) e limpa os params da URL, para que um F5 depois
   * de fechar a modal não a reabra.
   */
  private openPendingBuyTokensModal(): void {
    if (!this.pendingBuyTokens) return;
    this.pendingBuyTokens = false;
    // O deep link vem do app e não sabe qual é o plano; a mesma regra dos botões vale
    // aqui, senão o Free entra pela URL.
    if (this.canBuyTokens) {
      this.showBuyTokensModal = true;
    }
    this.clearBuyDeepLinkParams();
  }

  /**
   * Consome o deep link ?buy=2 (uma vez). Diferente do ?buy=1, não depende da aba: o
   * planInformation carrega no ngOnInit, então /profile/subscription?buy=2 também vale.
   */
  private openPendingPlansModal(): void {
    if (!this.pendingPlans) return;
    this.pendingPlans = false;
    this.showUpgradeModal = true;
    this.clearBuyDeepLinkParams();
  }

  /**
   * queryParamsHandling 'merge' com null remove só as chaves do deep link e preserva as
   * demais (ex.: tunnerCode).
   */
  private clearBuyDeepLinkParams(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { buy: null, from: null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  // ─── AI consumption ─────────────────────────────────────────────────────

  loadAiUsage(): void {
    this.aiUsageLoading = true;
    this.aiUsageError = false;
    this.aiService.getUsage().subscribe({
      next: (data) => {
        this.aiUsage = data;
        this.computeTankState();
        this.startReserveCountdown();
        this.aiUsageLoading = false;
        this.openPendingBuyTokensModal();
      },
      error: () => {
        // 404 não significa mais "usuário sem IA": desde a reserva gratuita o endpoint
        // responde 200 com credits zerados e o conteúdo em `free_tank`. Sobrou só como
        // "sem assinatura ativa", que é estado quebrado — trata como falha, igual às demais.
        this.aiUsageLoading = false;
        this.aiUsageError = true;
        this.messageService.add({
          severity: 'error',
          summary: this.translocoService.translate('user.account.aiLoadError'),
        });
      },
    });
  }

  /** Tamanho do corte do query_preview no servidor — usado só pra decidir as reticências. */
  private static readonly QUERY_PREVIEW_MAX = 60;

  /**
   * Prévia da pergunta que gerou o débito, com "…" quando o servidor cortou.
   *
   * O corte chega sem reticências e não há flag dizendo que houve corte: o único sinal é o
   * tamanho ter batido no limite. Um texto de exatamente 60 caracteres que não foi cortado
   * ganha "…" indevidamente — é o custo aceito no contrato, e o erro é invisível na prática.
   */
  aiHistoryPreview(item: AiUsageHistoryItem): string {
    const preview = item.query_preview;
    if (!preview) return '';
    return preview.length >= AccountComponent.QUERY_PREVIEW_MAX ? `${preview}…` : preview;
  }

  /** true quando o histórico veio com tank_size_tokens e a coluna pode exibir % do tanque. */
  hasHistoryTankSize(): boolean {
    return !!this.aiHistoryTankSize && this.aiHistoryTankSize > 0;
  }

  /**
   * Formata um movimento do histórico na unidade do tanque, com sinal — a mesma leitura do
   * medidor logo acima, pra o usuário não precisar converter crédito de cabeça.
   *
   * Abaixo de um tanque: percentual. De um tanque pra cima: contagem em tanques, COM fração
   * (ex.: "+2.7 tanques"). Diferente do medidor, que arredonda pra inteiro: lá o número é um
   * saldo que o usuário interpreta ("quantos tanques ainda tenho"), aqui é o registro exato
   * de um movimento que aconteceu, e a fração informa em vez de confundir.
   *
   * Sem tank_size_tokens, cai no número de créditos (comportamento anterior).
   */
  formatAiHistoryAmount(amount: number): string {
    const sign = amount >= 0 ? '+' : '-';
    const abs = Math.abs(amount);

    if (!this.hasHistoryTankSize()) {
      return sign + (this.decimalPipe.transform(abs, '1.0-0') ?? abs);
    }

    const tankSize = this.aiHistoryTankSize!;

    if (abs < tankSize) {
      const percent = (abs / tankSize) * 100;
      // Duas casas abaixo de 0,1%: um chat barato custa frações de 1% do tanque, e com uma
      // casa fixa todo movimento pequeno viraria "0.0%", que parece defeito.
      const digits = percent > 0 && percent < 0.1 ? '1.2-2' : '1.1-1';
      // Abaixo de um tanque cheio o percentual nunca deve arredondar até 100%: 99,99% viraria
      // "-100.0%" numa linha, ao lado de "-1 tanque" na outra, para valores diferentes.
      const shown = percent > 99.9 ? 99.9 : percent;
      return `${sign}${this.decimalPipe.transform(shown, digits)}%`;
    }

    const tanks = abs / tankSize;
    const rounded = Math.round(tanks * 10) / 10;
    // Exatamente um tanque sai como "1 tanque", não "1.0 tanques".
    const isOne = rounded === 1;
    const value = isOne ? '1' : this.decimalPipe.transform(tanks, '1.1-1');
    const unit = this.translocoService.translate(
      isOne ? 'user.account.aiTankUnitOne' : 'user.account.aiTankUnitMany'
    );
    return `${sign}${value} ${unit}`;
  }

  loadAiHistory(page: number = 1): void {
    this.aiHistoryLoading = true;
    this.aiHistoryPage = page;
    this.aiService.getUsageHistory(page, this.aiHistoryPageSize).subscribe({
      next: (data) => {
        this.aiHistory = data.items;
        this.aiHistoryTotalCount = data.total_count;
        this.aiHistoryTankSize = data.tank_size_tokens || null;
        this.aiHistoryLoaded = true;
        this.aiHistoryLoading = false;
      },
      error: () => {
        this.aiHistoryLoading = false;
      },
    });
  }

  onAiHistoryPageChange(event: any): void {
    const page = Math.floor(event.first / event.rows) + 1;
    if (page === this.aiHistoryPage && this.aiHistory.length > 0) return;
    this.loadAiHistory(page);
  }

  getUsagePercent(): number {
    if (!this.aiUsage || this.aiUsage.credits_total <= 0) return 100;
    return (this.aiUsage.credits_used_this_period / this.aiUsage.credits_total) * 100;
  }

  getAiTypeLabel(type: string): string {
    const key = `user.account.aiTypeLabels.${type}`;
    const label = this.translocoService.translate(key);
    // Transloco devolve a própria key quando não encontra tradução — nesse caso,
    // mostra o type cru (ex.: tipo novo que ainda não ganhou label específico).
    return label === key ? type : label;
  }

  getAiTypeIcon(type: string): string {
    const icons: Record<string, string> = {
      'ai_chat_message': 'pi-comments',
      'subscription_grant': 'pi-sync',
      'admin_adjust': 'pi-user-edit',
      'credit_stripe': 'pi-credit-card',
      'manual_carryover': 'pi-history',
      'subscription_not_used': 'pi-calendar-times',
      'purchase': 'pi-shopping-cart',
      'purchase_expired': 'pi-hourglass',
    };
    return icons[type] || 'pi-circle';
  }

  /** Só alguns tipos têm explicação extra (tooltip) — os demais retornam vazio. */
  getAiTypeDescription(type: string): string {
    const key = `user.account.aiTypeDescriptions.${type}`;
    const description = this.translocoService.translate(key);
    return description === key ? '' : description;
  }

  getUsageBarClass(): string {
    const percent = this.getUsagePercent();
    if (percent >= 85) return 'ai-bar-red';
    if (percent >= 60) return 'ai-bar-yellow';
    return 'ai-bar-green';
  }

  // ─── Medidor de "tanques" (tank_size_tokens) ───────────────────────────
  // credits_total/credits_used_this_period expressos em unidades de tank_size_tokens.
  // Campo novo e opcional — hasTankGauge() decide se usa esse display ou o fallback
  // percentual antigo (ai-usage-bar), pra planos/ambientes que ainda não o retornam.

  hasTankGauge(): boolean {
    return !!this.aiUsage?.tank_size_tokens && this.aiUsage.tank_size_tokens > 0;
  }

  /**
   * Escala do mostrador: um traço a cada 6,25% (17 no total), os múltiplos de 25%
   * mais longos. Estático — a geometria não depende dos dados, só o ponteiro gira.
   * `rotate` usa o pivô do mostrador (100,104) no viewBox "0 0 200 120".
   */
  /**
   * Escala do mostrador: 9 traços a cada 22,5° da varredura de 180°, os múltiplos
   * de 45° mais longos. Geometria estática — só o ponteiro gira. Pivô em (100,104)
   * no viewBox "0 0 200 132".
   */
  readonly gaugeTicks = [-90, -67.5, -45, -22.5, 0, 22.5, 45, 67.5, 90].map((deg) => ({
    major: deg % 45 === 0,
    y2: deg % 45 === 0 ? 41 : 38,
    transform: `rotate(${deg} 100 104)`,
  }));

  /**
   * Estado do medidor, recalculado a cada carga de GET /AI/usage. Só o tanque em uso
   * é desenhado: como o consumo drena um tanque por vez, todos os de trás estão
   * necessariamente cheios — desenhá-los não diria nada além da contagem.
   */
  /** Capacidade do tanque em uso (0..1). O último tanque pode ser parcial, se a compra não fechou um tanque inteiro. */
  currentTankCapacity: number = 0;
  /** Combustível que ainda resta no tanque em uso, na mesma escala da capacidade (0..1). */
  currentTankRemaining: number = 0;
  /** Tanques intactos atrás do atual. */
  reserveTanks: number = 0;
  /** Quantos tanques ainda têm combustível, incluindo o em uso. */
  tanksWithFuel: number = 0;

  /**
   * Limiares da escala, em % do tanque em uso. São só marcações impressas no
   * mostrador — dizem onde é o fim DESTE tanque, não que o crédito acabou.
   */
  readonly reserveThreshold = 15;
  readonly dryThreshold = 6;

  /**
   * Luz de reserva. Acende quando o tanque em uso está baixo **e não há nenhum
   * atrás dele** — sem a segunda condição a luz piscaria a cada troca de tanque
   * (cinco vezes por período num plano de cinco), porque esvaziar um tanque não é
   * evento: o próximo entra em uso na hora. É o mesmo critério que o texto de
   * ajuda desta tela descreve.
   */
  get isOnReserve(): boolean {
    if (!this.hasTankGauge()) return false;
    return this.tanksWithFuel <= 1 && this.getCurrentTankPercent() <= this.reserveThreshold;
  }

  /**
   * Cor do líquido do galão. Âmbar e vermelho só entram quando NÃO há tanque
   * atrás — com reserva cheia, esvaziar o tanque em uso não é problema e pintar
   * de vermelho seria alarme falso, do mesmo jeito que seria acender a luz.
   */
  get tankLevelColor(): string {
    // #6dde8a é o verde de combustível que este componente já usava (era o
    // --fuel-top do líquido em CSS). Não existe token --ftds-ok: o verde do design
    // system é --ftds-success (#22c55e), mais saturado do que o do combustível.
    if (!this.isOnReserve) return '#6dde8a';
    return this.getCurrentTankPercent() <= this.dryThreshold
      ? 'var(--ftds-danger)'
      : 'var(--ftds-warn)';
  }

  /** Contorno do galão: acompanha o líquido; cinza quando está seco. */
  get tankOutlineColor(): string {
    return this.getCurrentTankPercent() > 0 ? this.tankLevelColor : '#3a3d44';
  }

  // Geometria do líquido dentro do corpo do galão (viewBox "0 0 118 116"):
  // o corpo vai de y=34 a y=104, 70u ao todo.

  /**
   * Altura do líquido em 100%. Menor que os 70u do corpo de propósito: os 4u de folga no
   * topo são lâmina de ar. Sem ela o tanque cheio encosta na tampa, não sobra superfície
   * e a onda não tem onde aparecer — as cristas caem acima de y=34 e o corpo as recorta.
   * Um recipiente cheio de verdade também tem essa folga.
   */
  private static readonly LIQUID_MAX_HEIGHT = 66;

  get canLiquidHeight(): number {
    return (this.getCurrentTankPercent() / 100) * AccountComponent.LIQUID_MAX_HEIGHT;
  }

  get canLiquidY(): number {
    return 104 - this.canLiquidHeight;
  }

  get canShineHeight(): number {
    return Math.max(0, this.canLiquidHeight - 8);
  }

  /**
   * Onda da superfície. Período de 24u repetido de -24 a 96 — bem mais largo que os 56u
   * do corpo do galão, então a emenda do loop nunca entra em cena. Fecha 14u pra baixo
   * pra encostar no corpo do líquido sem deixar fresta nas cavas.
   */
  readonly canWavePath =
    'M-24 0 Q-18 -3 -12 0 T0 0 T12 0 T24 0 T36 0 T48 0 T60 0 T72 0 T84 0 T96 0 V14 H-24 Z';

  /**
   * Bolhas subindo no combustível. Array `readonly` porque o *ngFor compara por
   * identidade: recriar a lista a cada ciclo de detecção remontaria os elementos e
   * reiniciaria as animações sem parar. Tamanhos, posições, durações, atrasos e deriva
   * todos diferentes — em lockstep elas denunciariam o padrão na hora.
   *
   * `cx` entre 30 e 59: o corpo vai de 14 a 70, e mais à esquerda a bolha cruzaria o
   * chanfro e sumiria cortada em vez de desbotar.
   */
  readonly canBubbles = [
    { cx: 30, r: 2.5, duration: '3.4s', delay: '0s',   drift: '2px' },
    { cx: 38, r: 1.5, duration: '4.6s', delay: '0.9s', drift: '-1.5px' },
    { cx: 45, r: 2,   duration: '3.9s', delay: '1.8s', drift: '1.5px' },
    { cx: 52, r: 3,   duration: '5.2s', delay: '0.4s', drift: '-2px' },
    { cx: 59, r: 1.5, duration: '4.1s', delay: '2.6s', drift: '1px' },
  ];

  private tanksTotal(): number {
    if (!this.hasTankGauge()) return 0;
    return this.aiUsage!.credits_total / this.aiUsage!.tank_size_tokens!;
  }

  private tanksUsed(): number {
    if (!this.hasTankGauge()) return 0;
    return this.aiUsage!.credits_used_this_period / this.aiUsage!.tank_size_tokens!;
  }

  private computeTankState(): void {
    const total = this.tanksTotal();
    const used = this.tanksUsed();
    const clamp = (v: number) => Math.min(1, Math.max(0, v));
    const index = Math.floor(used);

    this.currentTankCapacity = clamp(total - index);
    this.currentTankRemaining = Math.max(0, this.currentTankCapacity - clamp(used - index));
    // O último da reserva pode ter capacidade parcial, mas ainda é um tanque com
    // combustível — por isso conta por tanque físico (ceil), não por fração.
    this.reserveTanks = Math.max(0, Math.ceil(total) - index - 1);
    this.tanksWithFuel = (this.currentTankRemaining > 0 ? 1 : 0) + this.reserveTanks;
  }

  /**
   * % de combustível que resta no tanque em uso, relativo à capacidade DELE — o
   * último tanque pode ser parcial (compra que não fechou um tanque inteiro), e aí
   * "meio tanque" dele não é 50% de um tanque cheio.
   */
  getCurrentTankPercent(): number {
    if (this.currentTankCapacity <= 0) return 0;
    return Math.round((this.currentTankRemaining / this.currentTankCapacity) * 100);
  }

  /** Rotação do ponteiro: -90° em 0% (vazio, aponta pra E) a +90° em 100% (cheio, aponta pra F). */
  getNeedleRotation(): string {
    return `rotate(${(this.getCurrentTankPercent() / 100) * 180 - 90}deg)`;
  }

  /** Janela de exibição decidida no front (contrato não filtra): só avisa dentro de 30 dias do vencimento. */
  private static readonly EXPIRING_WARNING_WINDOW_DAYS = 30;

  shouldShowExpiringWarning(): boolean {
    if (!this.aiUsage?.next_expiring_amount || !this.aiUsage?.next_expiring_at) return false;
    const days = this.getExpiringDays();
    return days >= 0 && days <= AccountComponent.EXPIRING_WARNING_WINDOW_DAYS;
  }

  getExpiringDays(): number {
    if (!this.aiUsage?.next_expiring_at) return 0;
    const diffMs = new Date(this.aiUsage.next_expiring_at).getTime() - Date.now();
    return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
  }

  getExpiringDateFormatted(): string {
    if (!this.aiUsage?.next_expiring_at) return '';
    const d = new Date(this.aiUsage.next_expiring_at);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}/${d.getFullYear()}`;
  }

  /**
   * Lote de tanques comprados que vence primeiro. `next_expiring_amount` vem em
   * créditos e o painel fala em tanques, então converte pela mesma escala do
   * medidor. Não é o total comprado — é só o lote com o vencimento mais próximo,
   * que é o que a API expõe.
   */
  get expiringTanks(): number {
    if (!this.hasTankGauge() || !this.aiUsage?.next_expiring_amount) return 0;
    return this.aiUsage.next_expiring_amount / this.aiUsage.tank_size_tokens!;
  }

  /**
   * Barra de prazo do lote: fração da janela de aviso que ainda resta. O bloco só
   * aparece dentro da janela, então a barra mede exatamente o intervalo que cobre —
   * a data de compra não vem no contrato, então não há como medir os 12 meses.
   */
  get expiringWindowPercent(): number {
    return (this.getExpiringDays() / AccountComponent.EXPIRING_WARNING_WINDOW_DAYS) * 100;
  }

  /** Prazo em dias, com singular/plural e "hoje" — mesmo padrão de tankLeftLabel/tanksLeftLabel. */
  get expiringInKey(): string {
    const days = this.getExpiringDays();
    if (days === 0) return 'user.account.tankExtraExpiringToday';
    return days === 1
      ? 'user.account.tankExtraExpiringInDay'
      : 'user.account.tankExtraExpiringInDays';
  }

  // ─── Reserva gratuita (free_tank) ──────────────────────────────────────
  // Cota que recarrega a cada janela e só é gasta com o crédito pago em zero. Reaproveita
  // o mesmo galão do medidor, em escala menor e em laranja: menor porque a cota é menor
  // que um tanque, laranja porque é outro tipo de crédito — não é o semáforo de nível
  // (tankLevelColor), que aqui não se aplica. O ponteiro e o galão grande ficam como
  // estão: com o crédito pago zerado eles já mostram vazio sozinhos.

  get freeTank(): AiFreeTank | null {
    return this.aiUsage?.free_tank ?? null;
  }

  /**
   * Plano com cota mensal. O bloco de período (janela + dia de renovação) só faz sentido
   * aqui: ele diz quando a cota renova, e o Free não tem cota nenhuma — o período dele é
   * só o aniversário da assinatura, sem crédito atrelado. Mostrar "renovação no dia 5"
   * pra ele é informação falsa.
   *
   * A condição era `credits_limit > 0`, que nunca excluía o Free — ele chega com 10000 —,
   * então o bloco aparecia justamente para quem a regra queria poupar.
   *
   * A condição NÃO é `free_tank.active`: a reserva também fica ativa no plano pago que
   * esgotou os créditos, e ali o período é a informação mais útil da tela — é quando os
   * créditos dele voltam. Esconder nesse caso tiraria justamente o que a pessoa quer saber;
   * por isso `isPaidPlan` ignora vigência.
   */
  get hasMonthlyQuota(): boolean {
    return isPaidPlan(this.aiUsage);
  }

  /** Compra de tanque extra: exige plano pago E assinatura ativa. */
  get canBuyTokens(): boolean {
    return canBuyExtraTokens(this.aiUsage, this.planInformation?.status);
  }

  /** A regra da cortesia é informativa: vale enquanto a conta tiver o tanque. */
  get showReserveRule(): boolean {
    return shouldShowReserveRule(this.freeTank);
  }

  get reserveState(): FreeTankState {
    return freeTankState(this.freeTank);
  }

  /** A reserva é a fonte de gasto e substitui a leitura do medidor. */
  get isReserveActive(): boolean {
    return isFreeTankInUse(this.freeTank);
  }

  get reserveRemaining(): number {
    return freeTankRemainingDisplay(this.freeTank);
  }

  get reserveFillPercent(): number {
    return freeTankFillPercent(this.freeTank);
  }

  /** Escala do galão da reserva dentro do mesmo viewBox — ver o <g transform> no template. */
  readonly reserveCanScale = 0.55;

  // Mesma geometria do galão principal (corpo de y=34 a y=104), só que alimentada pela
  // reserva; o encolhimento vem do transform, não das medidas.
  get reserveLiquidHeight(): number {
    return (this.reserveFillPercent / 100) * AccountComponent.LIQUID_MAX_HEIGHT;
  }

  get reserveLiquidY(): number {
    return 104 - this.reserveLiquidHeight;
  }

  get reserveShineHeight(): number {
    return Math.max(0, this.reserveLiquidHeight - 8);
  }

  /**
   * Reserva em uso num plano que não compra tanque: a saída é assinar, não comprar avulso.
   * Plano pago que esgotou a cota continua com o CTA de compra, que resolve na hora.
   *
   * A condição era `!hasMonthlyQuota`, que nunca valia: o Free chega com credits_limit
   * 10000. Por isso este convite não aparecia justamente para quem precisava dele.
   */
  get showReserveUpgradeCta(): boolean {
    return this.isReserveActive && !this.canBuyTokens;
  }

  /**
   * Mesmo antes de a reserva entrar, quem não pode comprar precisa de uma saída. Sem isto
   * o card ficava com o texto vendendo tanques extra e nenhum botão — pior do que não
   * existir. Cobre tanto o Free quanto o plano pago fora de vigência: nos dois a ação é
   * a mesma tela de planos.
   */
  get showPlanUpgradeCta(): boolean {
    return !!this.aiUsage && !this.isReserveActive && !this.canBuyTokens;
  }

  /** Minutos até o refill, atualizados de minuto em minuto. Null no estado prospectivo. */
  reserveMinutesLeft: number | null = null;
  private reserveTimer: ReturnType<typeof setInterval> | null = null;

  /**
   * Passo de um minuto: o refill é medido em horas, e um tique por segundo só gastaria
   * change detection pra redesenhar o mesmo texto.
   */
  private startReserveCountdown(): void {
    this.stopReserveCountdown();
    this.reserveMinutesLeft = freeTankMinutesToRefill(this.freeTank);
    if (this.reserveMinutesLeft === null) return;
    this.reserveTimer = setInterval(() => {
      this.reserveMinutesLeft = freeTankMinutesToRefill(this.freeTank);
      // Chegou a zero: a janela virou e o payload em mãos ficou velho. Continuar tiqueando
      // só redesenharia "em 0min" pra sempre — o número certo vem na próxima carga.
      if (!this.reserveMinutesLeft) this.stopReserveCountdown();
    }, 60_000);
  }

  private stopReserveCountdown(): void {
    if (this.reserveTimer) {
      clearInterval(this.reserveTimer);
      this.reserveTimer = null;
    }
  }

  /** "5h12" / "12min" — o refill é distante o bastante pra não precisar de segundos. */
  get reserveCountdownLabel(): string {
    const minutes = this.reserveMinutesLeft;
    if (minutes === null) return '';
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return hours > 0 ? `${hours}h${String(rest).padStart(2, '0')}` : `${rest}min`;
  }

  /** Origem do crédito de cada lançamento do extrato, pra tag ao lado do tipo. */
  aiHistoryOrigin(item: AiUsageHistoryItem): 'reserve' | 'purchase' | 'plan' {
    return historyCreditOrigin(item);
  }

  // ─── Invoices (recibos) ─────────────────────────────────────────────────

  openInvoiceDetail(id: string): void {
    this.selectedInvoiceId = id;
    this.showInvoiceDetailModal = true;
  }

  onInvoiceNotFound(): void {
    this.messageService.add({
      key: 'toastAccount',
      severity: 'error',
      summary: this.translocoService.translate('user.account.subscriptionTab.invoices.notFound'),
    });
  }

  // Recarrega a lista da lixeira a partir da API (fonte de verdade) apos restaurar/excluir,
  // em vez de apenas remover o item localmente.
  private async reloadTrash(): Promise<void> {
    if (!this.userId) return;
    try {
      this.loadingTrash = true;
      const trashList = await lastValueFrom(
        this.trashService.getTrashList(this.userId)
      );
      this.itensTrash = Trash.fromArray(trashList);
    } finally {
      this.loadingTrash = false;
    }
  }

  restore(item: Trash): void {
    const request = new TrashRestoreRequest(item.id, item.type);
    if (this.userId && request) {
      this.translocoService
        .selectTranslateObject("user.trash")
        .subscribe((value) =>
          this.confirmationService.confirm({
            message: value.confirmationRestoreMessage,
            header: value.restoreItem,
            icon: "pi pi-info-circle",
            acceptButtonStyleClass: "p-button-danger",
            rejectButtonStyleClass: "p-button-text",
            acceptLabel: value.yes,
            rejectLabel: value.no,
            acceptIcon: "none",
            rejectIcon: "none",
            accept: () => {
              if (!this.userId) return;
              this.trashService.trashRestore(this.userId, [request]).subscribe({
                next: () => {
                  this.translocoService
                    .selectTranslate("user.trash.successRestore")
                    .subscribe((value) => {
                      this.messageService.clear();
                      this.messageService.add({
                        key: "toastAccount",
                        severity: "success",
                        summary: value,
                      });
                    });
                  this.itensTrash = this.itensTrash.filter(
                    (i) => i.id !== item.id
                  );
                  this.reloadTrash();
                },
                error: () => {
                  this.translocoService
                    .selectTranslate("user.trash.errorRestore")
                    .subscribe((value) => {
                      this.messageService.clear();
                      this.messageService.add({
                        key: "toastAccount",
                        severity: "error",
                        summary: value,
                      });
                    });
                },
                complete: () => {},
              });
            },
            reject: () => {},
          })
        )
        .unsubscribe();
    }
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, "contains");
  }

  onEnterPress(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();
  }

  createForm(account: Account) {
    this.form = this.formBuilder.group({
      id: [account.id],
      country: [account.country, CustomValidator.getRequired()],
      name: [account.name, [...CustomValidator.getRequired(), Validators.pattern(/^[a-zA-ZÀ-ÿ\s'\-]+$/)]],
      docType: [account.docType],
      docNumber: [account.docNumber],
      birthDate: [account.birthDate, CustomValidator.getRequired()],
      phone: [account.phone, CustomValidator.getRequired()],
      phoneCountry: [account.phoneCountry, CustomValidator.getRequired()],
      email: [account.email, CustomValidator.getEmail()],
      language: [account.language, CustomValidator.getRequired()],
      checkNewsletter: [account.checkNewsletter],
      inactive: [account.inactive],
      inactiveReason: [account.inactiveReason],
    });
  }
  createChangePasswordForm() {
    this.changePasswordForm = this.formBuilderPass.group({
      oldPassword: ["", CustomValidator.getPassword()],
      newPassword: ["", CustomValidator.getPassword()],
    });
  }

  onSubmit() {
    this.submitBtnLoading = true
    this.messageService.clear();
    if (this.f.country.invalid) this.f.country.markAsDirty();
    if (this.f.name.invalid) this.f.name.markAsDirty();
    //if(this.isBrasil && this.f.docNumber.invalid) this.f.docNumber.markAsDirty()
    if (DocTypeEnum.CPF === this.f.docType.value.id && this.f.birthDate.invalid)
      this.f.birthDate.markAsDirty();
    //if(this.f.phone.invalid) this.f.phone.markAsDirty()
    if (this.f.email.invalid) this.f.email.markAsDirty();
    if (this.form.valid) {
      if (!this.f.inactive.value) this.f.inactiveReason.setValue(null);
      let payload = this.accountService.toAccountRequest(
        this.form.value,
        this.verifyInactive()
      );

      if (this.accessToken) {
        this.authService
          .setUserMFA(this.mfaEnabled)
          .then(() => {
            console.log("MFA Ativado");
          })
          .catch(() => {
            console.log("Erro ao ativar MFA");
          });
      }

      this.accountService.updateAccountFix(payload).subscribe({
        next: (response) => {
          sessionStorage.setItem("language", response.language);
          this.messageService.clear();
          this.translocoService
            .selectTranslate("user.account.success")
            .subscribe((value) => {
              this.messageService.add({
                key: "toastAccount",
                severity: "success",
                summary: value,
              });
            });
          this.submitBtnLoading = false;
        },
        error: () => {
          this.messageService.clear();
          this.translocoService
            .selectTranslate("errorConection")
            .subscribe((value) => {
              this.messageService.add({
                key: "toastAccount",
                severity: "error",
                summary: value,
              });
            });
          //     this.submitBtnLoading = false;
        },
      });
    } else {
      this.translocoService
        .selectTranslate("inputRequired")
        .subscribe((value) => {
          this.messageService.clear();
          this.messageService.add({
            key: "toastAccount",
            severity: "error",
            summary: value,
          });
        });
    }
  }

  adaptForm() {
    this.setTitle();
    if (this.account.country.id !== 0) {
      this.account.country = this.countryOptions.filter(
        (c) => c.id === this.account.country.id
      )[0];
      this.f.country.setValue(this.account.country);
    }
    this.setIsBrasil();
    this.setDateInterval();
    this.fixLanguage();
    this.beforeInactive = this.f.inactive.value;
    this.messageService.clear();
    this.f.docNumber.disable();
    this.f.email.disable();

    if (this.f.inactiveReason.value === null) {
      this.f.inactiveReason.setValue(
        this.inactiveReasonOptions.length > 0
          ? this.inactiveReasonOptions[0]
          : null
      );
    }
    if (this.beforeInactive) {
      this.f.inactive.disable();
      this.f.inactiveReason.disable();
    }
    this.cdr.detectChanges();
  }

  public setIsBrasil() {
    if (
      "Brasil" === this.f.country.value.name ||
      "Brazil" === this.f.country.value.name
    ) {
      this.isBrasil = true;
      this.isBrasilDate = true;
      this.getMaskDocNumber();
      this.showBirthDateAndName();
      this.f.docNumber.setValidators(CustomValidator.getRequired());
    } else {
      this.isBrasil = false;
      this.isBrasilDate = false;
      this.docType = null;
      this.showBirthDate = true;
      this.f.docNumber.setValue(this.account.docNumber ?? null);
      // this.f.docNumber.enable();
      this.f.docNumber.clearValidators();
      this.f.docNumber.setErrors(null);
    }
    this.f.birthDate.updateValueAndValidity();
    this.cdr.detectChanges();
  }

  setDateInterval() {
    let today = new Date();
    this.maxDate = new Date();
    this.maxDate.setDate(today.getDate() - 1);
  }

  fixLanguage() {
    this.messageService.clear();
    this.language = this.f.language.value;
    if (this.lastLanguage !== this.language) {
      this.languageOptions
        .filter((opt) => opt.name === this.language.name)
        .map((cty) => (cty.disabled = true));
      this.languageOptions
        .filter((opt) => opt.name !== this.language.name)
        .map((cty) => (cty.disabled = false));
      this.lastLanguage = this.language;
      this.changeLanguage(this.language.name);
    }
  }

  /**
   * Idioma vale na hora: troca a interface e persiste sozinho, sem depender do botão Salvar.
   * Só o idioma é gravado: o restante do payload sai do snapshot salvo da conta, não do formulário,
   * para não empurrar edições que o usuário ainda não confirmou.
   */
  onLanguageSelected(): void {
    const previous = this.lastLanguage;
    this.fixLanguage();
    if (previous === this.language) { return; }

    const payload = this.accountService.toAccountRequest(
      { ...this.account, language: this.language },
      this.account.inactiveReason
    );
    this.accountService.updateAccountFix(payload).subscribe({
      next: (response) => {
        this.account.language = this.language;
        if (this.accountDB) { this.accountDB.language = this.language; }
        sessionStorage.setItem("language", response.language);
        this.toast("success", "user.account.languageSaved");
      },
      error: () => {
        // Volta ao idioma anterior para a tela não mostrar um idioma que não foi gravado.
        this.f.language.setValue(previous);
        this.fixLanguage();
        this.toast("error", "errorConection");
      },
    });
  }

  private toast(severity: "success" | "error", key: string): void {
    this.messageService.clear();
    this.messageService.add({ key: "toastAccount", severity, summary: this.translocoService.translate(key) });
  }

  backPage() {
    if (!this.deepEquals(this.form.value, this.accountDB)) {
      this.backBtnLoading = true;
      this.translocoService
        .selectTranslate("noSaved")
        .subscribe((value) => {
          this.messageService.clear();
          this.messageService.add({
            key: "toastAccount",
            severity: "error",
            summary: value,
          });
        })
        .unsubscribe();

      setTimeout(() => {
        this.location.back();
      }, 3000); //3s
    } else {
      this.location.back();
    }
  }

  deepEquals(form: Account, db: Account): boolean {
    if (form && db) {
      if (form.country.id !== db.country.id) return false;
      if (form.name !== db.name) return false;
      if (form.birthDate?.getTime() !== db.birthDate?.getTime()) return false;
      if (this.removeMask(form.phone) !== this.removeMask(db.phone))
        return false;
      if (form.language !== db.language) return false;
      if (form.checkNewsletter !== db.checkNewsletter) return false;
    }
    return true;
  }

  setTitle() {
    this.translocoService
      .selectTranslate("title.account")
      .subscribe((value) => this.titleService.setTitle(value));
  }

  setPlaceHolderNameCpf() {
    this.translocoService
      .selectTranslate("user.createAccount.fullName")
      .subscribe((value) => (this.placeHolderName = value + "*"));
  }
  setPlaceHolderNameCnpj() {
    this.translocoService
      .selectTranslate("user.createAccount.companyName")
      .subscribe((value) => (this.placeHolderName = value + "*"));
  }

  showBirthDateAndName() {
    if (DocTypeEnum.CPF === this.f.docType.value.id) {
      this.setPlaceHolderNameCpf();
      this.showBirthDate = true;
    } else if (DocTypeEnum.CNPJ === this.f.docType.value.id) {
      this.setPlaceHolderNameCnpj();
      this.showBirthDate = false;
      this.f.birthDate.setValidators(null);
    }
  }

  verifyInactive(): Reason | null {
    // se esta sendo inativado, retorna o motivo definido no form, senao mantem o motivo do getUser
    if (!this.beforeInactive && this.f.inactive.value)
      return this.f.inactiveReason.value;
    return this.account.inactiveReason;
  }

  getMaskDocNumber() {
    this.messageService.clear();
    let docNumber = this.removeMask(this.f.docNumber.value);
    if (docNumber.length === 11) {
      docNumber = this.addMaskCPF(docNumber);
      this.f.docNumber.setValue(docNumber);
      if (this.validCPF(docNumber)) {
        this.docType = DocType.CPF;
        this.setPlaceHolderNameCpf();
        this.showBirthDate = true;
      } else {
        this.invalidateCPF();
      }
    } else if (docNumber.length === 14) {
      docNumber = this.addMaskCNPJ(docNumber);
      this.f.docNumber.setValue(docNumber);
      let valido = this.validCNPJ(docNumber);
      if (this.validCNPJ(docNumber)) {
        this.docType = DocType.CNPJ;
        this.setPlaceHolderNameCnpj();
        this.showBirthDate = false;
      } else {
        this.invalidateCNPJ();
      }
    } else {
      this.f.docNumber.setValue("");
    }
  }

  private invalidateCPF() {
    this.f.docNumber.markAsDirty();
    this.f.docNumber.setErrors({ nomatch: true });
    this.messageService.clear();
    this.translocoService
      .selectTranslate("user.createAccount.cpfValid")
      .subscribe((value) =>
        this.messageService.add({
          key: "toastAccount",
          severity: "error",
          summary: value,
        })
      );
  }

  private invalidateCNPJ() {
    this.f.docNumber.markAsDirty();
    this.f.docNumber.setErrors({ nomatch: true });
    this.messageService.clear();
    this.translocoService
      .selectTranslate("user.createAccount.cnpjValid")
      .subscribe((value) =>
        this.messageService.add({
          key: "toastAccount",
          severity: "error",
          summary: value,
        })
      );
  }

  private validCPF(value: string): boolean {
    return cpf.isValid(this.removeMask(value));
  }

  private validCNPJ(value: string): boolean {
    return cnpj.isValid(this.removeMask(value));
  }

  private addMaskCPF(str: string): string {
    // '999.999.999-99'
    if (str === null) return "";
    str = str.replace(/\D/g, "");
    str = str.replace(/(\d{3})(\d)/, "$1.$2");
    str = str.replace(/(\d{3})(\d)/, "$1.$2");
    str = str.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    return str;
  }

  private addMaskCNPJ(str: string): string {
    // '99.999.999/9999-99'
    if (str === null) return "";
    str = str.replace(/\D/g, "");
    str = str.replace(/^(\d{2})(\d)/, "$1.$2");
    str = str.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    str = str.replace(/\.(\d{3})(\d)/, ".$1/$2");
    str = str.replace(/(\d{4})(\d)/, "$1-$2");
    return str;
  }

  private removeMask(str: string): string {
    if (str === null) return "";
    str = str.replaceAll(".", "");
    str = str.replaceAll("-", "");
    str = str.replaceAll("/", "");
    return str;
  }

  changeInactive(): void {
    if (this.f.inactive.value) {
      if (this.f.inactiveReason.value === null)
        this.f.inactiveReason.setValue(
          this.inactiveReasonOptions.length > 0
            ? this.inactiveReasonOptions[0]
            : null
        );
    } else {
      this.f.inactiveReason.setValue(null);
    }
  }

  public changeLanguage(languageCode?: string | null): void {
    if (!languageCode || languageCode === null)
      languageCode = sessionStorage.getItem("language");
    if (languageCode && languageCode !== null) {
      if (languageCode === "pt-br") {
        this.isBrasilDate = true;
        sessionStorage.setItem("language", languageCode);
      } else {
        this.isBrasilDate = false;
        sessionStorage.setItem("language", languageCode);
      }
      this.translocoService.setActiveLang(languageCode);
    }
  }

  /** A exclusão de conta virou uma página própria (/account/delete), com os avisos obrigatórios. */
  goToAccountDeletion() {
    this.router.navigate(["/account/delete"]);
  }

  showTrash(itemType: string): boolean {
    // Todos os tipos podem ser excluidos definitivamente (inclusive Project agora).
    if (
      itemType == "Vcu" ||
      itemType == "Log" ||
      itemType == "Map" ||
      itemType == "Project"
    )
      return true;
    return false;
  }

  // Icone (PrimeIcons) por tipo de item da lixeira, usado no redesign da aba.
  /** Rotulo da linha da lixeira. A API devolve `name` vazio para VCU (o
   *  /garbage manda so id, name, type, deletionDate — nao ha outro campo para
   *  usar), e sem isto a tabela mostrava varias linhas em branco, impossiveis
   *  de distinguir. Cai para tipo + id, que ao menos identifica o item. */
  trashLabel(item: { name?: string; type?: string; id?: string }): string {
    const nome = (item.name || '').trim();
    if (nome) return nome;
    const tipo = (item.type || '').toString().toUpperCase();
    return item.id ? `${tipo} ${item.id}` : tipo;
  }

  trashHasName(item: { name?: string }): boolean {
    return !!(item.name || '').trim();
  }

  trashTypeIcon(type: string): string {
    switch (type) {
      case "Project":
        return "pi pi-folder";
      case "Vcu":
        return "pi pi-microchip";
      case "Map":
        return "pi pi-map";
      case "Log":
        return "pi pi-chart-line";
      default:
        return "pi pi-file";
    }
  }

  trashPermanently(item: Trash) {
    this.translocoService
      .selectTranslateObject("user.trash.permanently")
      .subscribe((value) =>
        this.confirmationService.confirm({
          header: value.header,
          message: value.ask,
          icon: "pi pi-info-circle",
          acceptButtonStyleClass: "p-button-danger",
          rejectButtonStyleClass: "p-button-text",
          acceptLabel: value.yes,
          rejectLabel: value.no,
          acceptIcon: "none",
          rejectIcon: "none",
          accept: () => {
            let deleteObservable;
            if (item.type === "Vcu") {
              deleteObservable = this.trashService.trashPermanently(
                this.userId || "",
                item.id
              );
            } else if (item.type === "Project") {
              deleteObservable = this.trashService.trashPermanentlyProject(
                this.userId || "",
                item.id
              );
            } else {
              deleteObservable = this.trashService.DeletePermanentlyItemGarbage(
                this.userId || "",
                item.id,
                item.type
              );
            }

            deleteObservable.subscribe({
              next: () => {
                this.itensTrash = this.itensTrash.filter(
                  (i) => i.id !== item.id
                );
                this.reloadTrash();
                this.messageService.clear();
                this.translocoService
                  .selectTranslate("user.trash.successDelete")
                  .subscribe((successMessage) => {
                    this.messageService.add({
                      key: "trashtAccount",
                      severity: "success",
                      summary: successMessage,
                    });
                  });
              },
              error: () => {
                this.messageService.clear();
                this.translocoService
                  .selectTranslate("user.trash.errorDelete")
                  .subscribe((errorMessage) => {
                    this.messageService.add({
                      key: "trashtAccount",
                      severity: "error",
                      summary: errorMessage,
                    });
                  });
              },
            });
          },
          reject: () => {
            this.messageService.clear();
            this.translocoService
              .selectTranslate("user.trash.cancelDelete")
              .subscribe((cancelMessage) => {
                this.messageService.add({
                  key: "toastAccount",
                  severity: "info",
                  summary: cancelMessage,
                });
              });
          },
        })
      )
      .unsubscribe();
  }

  get f() {
    return this.form.controls;
  }

  get formPass() {
    return this.changePasswordForm.controls;
  }

  changePasswordUser(oldPass: string, newPass: string) {
    try {
      if (!this.accessToken) {
        throw new Error("Token vazio.");
      }

      this.authService.changePassword(oldPass, newPass)
        .then(() => {
          this.messageService.clear();
          this.messageService.add({
            key: "toastAccount",
            severity: "success",
            summary: "Troca de senha realizada com sucesso!",
          });
          this.showChagePasswordModal = false;
        })
        .catch((error: any) => {
          this.messageService.clear();
          const errorName = error?.name || '';
          
          let summary = "Erro ao alterar senha.";
          if (errorName === "NotAuthorizedException") {
            summary = "Incorrect username or password.";
          } else if (errorName === "LimitExceededException") {
            summary = "Attempt limit exceeded, please try after some time.";
          } else if (errorName === "InvalidParameterException") {
            summary = "Invalid Parameter.";
          } else if (errorName === "UserNotConfirmedException") {
            summary = "User not Confirmed.";
          } else if (errorName === "InternalErrorException") {
            summary = "Internal Error.";
          }

          this.messageService.add({
            key: "toastAccount",
            severity: "error",
            summary,
          });
        });
    } catch (error) {
      console.error("Erro ao alterar senha:", error);
    }
  }

  closeChangePasswordModal() {
    this.showChagePasswordModal = false;
  }

  checkPasswordInputs() {
    this.messagesPassword = [];
    if (this.formPass.oldPassword.invalid)
      this.formPass.oldPassword.markAsDirty();
    if (this.formPass.newPassword.invalid)
      this.formPass.newPassword.markAsDirty();
  }

  submitChangePassword() {
    this.checkPasswordInputs();
    if (this.changePasswordForm.valid) {
      this.changePasswordUser(
        this.formPass.oldPassword.value,
        this.formPass.newPassword.value
      );
    } else {
      this.translocoService
        .selectTranslate("inputRequired")
        .subscribe(
          (value) =>
            (this.messagesPassword = [{ severity: "error", summary: value }])
        );
    }
  }

  openChangePasswordModal() {
    this.createChangePasswordForm();
    this.messagesPassword = [];
    this.showChagePasswordModal = true;
  }

  /**
   * Consome o deep link ?changePassword=1 (uma vez) e limpa o param, para que um F5
   * depois de fechar a modal não a reabra — mesmo padrão do ?buy=1 acima. Vem do aviso
   * de uso simultâneo exibido no shell; o botão fica na aba 'data', que já é a inicial.
   */
  private openPendingChangePasswordModal(): void {
    const param = this.route.snapshot.queryParamMap.get('changePassword');
    if (param !== '1' && param !== 'true') return;
    this.openChangePasswordModal();
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { changePassword: null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  onPlanUpgraded(): void {
    if (!this.userId) return;
    this.accountService.getAccount(this.userId).subscribe((data) => {
      this.planInformation = data.planInformation;
      this.planFeatureService.load(data.planInformation);
      this.tunerGateLoading = false;
      this.accountType = data.accountType ?? null;
      this.tunerProfileId = data.tunerProfileId ?? null;
    });
  }

  /**
   * Só planos Pro/Ultra podem virar tuner. A regra é dado, não código:
   * MaxAffiliates != 0 no plano (0 = não pode, -1 = ilimitado).
   */
  get canBeTuner(): boolean {
    return this.planFeatureService.featureLimit('MaxAffiliates') !== 0;
  }

  /**
   * True enquanto o plano ainda não foi lido. Necessário porque 0 é um valor COM
   * significado ("plano não permite"), indistinguível de "ainda não sei" — sem isto,
   * um usuário Pro via o card bloqueado piscar em toda abertura da tela.
   */
  tunerGateLoading: boolean = true;

  becomeTuner(): void {
    if (!this.userId) return;
    this.confirmationService.confirm({
      message: this.translocoService.translate('tuner.becomeTuner.confirmMsg'),
      header: this.translocoService.translate('tuner.becomeTuner.confirmHeader'),
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: this.translocoService.translate('user.account.yes'),
      rejectLabel: this.translocoService.translate('user.account.no'),
      acceptIcon: 'none',
      rejectIcon: 'none',
      accept: () => {
        this.becomeTunerLoading = true;
        this.tunerService.becomeTuner(this.userId!).subscribe({
          next: (response) => {
            this.becomeTunerLoading = false;
            this.accountType = 'tuner';
            this.tunerProfileId = response.id;
            // Notifica outros componentes (dashboard-template / header) pra refazer o GET /user/{id}
            // e atualizar o accountType sem precisar de full page refresh.
            this.accountService.notifyAccountChanged();
            this.messageService.add({
              key: 'toastAccount',
              severity: 'success',
              summary: this.translocoService.translate('tuner.becomeTuner.success'),
            });
            this.router.navigate(['/tuner/dashboard']);
          },
          error: (err: HttpErrorResponse) => {
            this.becomeTunerLoading = false;
            const msg = err.status === 409
              ? this.translocoService.translate('tuner.becomeTuner.alreadyTuner')
              : this.translocoService.translate('tuner.becomeTuner.error');
            this.messageService.add({
              key: 'toastAccount',
              severity: 'error',
              summary: msg,
            });
          },
        });
      },
      reject: () => {},
    });
  }

  loadUserTuner(): void {
    if (!this.userId) return;
    this.userTunerLoading = true;
    this.tunerService.getUserTuner(this.userId).subscribe({
      next: (data) => {
        this.userTuner = data;
        this.userTunerLoading = false;
        if (this.pendingTunnerCode) {
          this.messageService.add({
            key: 'toastAccount',
            severity: 'warn',
            summary: this.translocoService.translate('tuner.myTuner.alreadyAffiliated'),
          });
          this.pendingTunnerCode = null;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.userTunerLoading = false;
        if (err.status !== 404) {
          console.error('Erro ao carregar tuner do usuário', err);
        }
        this.userTuner = null;
        if (this.pendingTunnerCode) {
          this.openAffiliatePanelWithCode(this.pendingTunnerCode);
          this.pendingTunnerCode = null;
        }
      },
    });
  }

  private openAffiliatePanelWithCode(code: string): void {
    this.setActiveTab('subscription');
    this.showAffiliatePanel = true;
    this.selectedAffiliateTunerId = null;
    this.affiliateMode = 'code';
    this.affiliateInviteCode = code;
    this.affiliateCodeError = '';
    this.validatedAffiliateTuner = null;
    this.affiliateTuners = [];
    this.affiliateCodeValidating = true;
    this.tunerService.validateInviteCode(code).subscribe({
      next: (tuner: TunerPublic) => {
        this.affiliateCodeValidating = false;
        this.validatedAffiliateTuner = tuner;
      },
      error: () => {
        this.affiliateCodeValidating = false;
        this.affiliateCodeError = this.translocoService.translate('tuner.myTuner.invalidCode');
      },
    });
  }

  goToTunerPanel(): void {
    this.router.navigate(['/tuner/dashboard']);
  }

  removeTuner(): void {
    if (!this.userId) return;
    this.confirmationService.confirm({
      message: this.translocoService.translate('tuner.myTuner.removeConfirmMsg'),
      header: this.translocoService.translate('tuner.myTuner.removeConfirmHeader'),
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: this.translocoService.translate('user.account.yes'),
      rejectLabel: this.translocoService.translate('user.account.no'),
      acceptIcon: 'none',
      rejectIcon: 'none',
      accept: () => {
        this.removeTunerLoading = true;
        this.tunerService.removeAffiliation(this.userId!).subscribe({
          next: () => {
            this.removeTunerLoading = false;
            this.userTuner = null;
            this.messageService.add({
              key: 'toastAccount',
              severity: 'success',
              summary: this.translocoService.translate('tuner.myTuner.removeSuccess'),
            });
          },
          error: () => {
            this.removeTunerLoading = false;
            this.messageService.add({
              key: 'toastAccount',
              severity: 'error',
              summary: this.translocoService.translate('tuner.myTuner.removeError'),
            });
          },
        });
      },
      reject: () => {},
    });
  }

  // ─── Affiliate tuner flow ────────────────────────────────────────────────

  openAffiliatePanel(): void {
    this.showAffiliatePanel = true;
    this.selectedAffiliateTunerId = null;
    this.affiliateMode = 'list';
    this.affiliateInviteCode = '';
    this.affiliateCodeError = '';
    this.validatedAffiliateTuner = null;
    this.affiliateTunersLoading = true;
    // Passa o plano: a API devolve só tuners elegíveis, com vaga e que aceitam
    // o tier. O front não sabe mais calcular isso — TunerTier é interno do backend.
    this.tunerService.getPublicTuners(this.planInformation?.planId ?? undefined).subscribe({
      next: (tuners) => {
        this.affiliateTuners = tuners;
        this.affiliateTunersLoading = false;
      },
      error: () => {
        this.affiliateTunersLoading = false;
        this.messageService.add({
          key: 'toastAccount',
          severity: 'error',
          summary: this.translocoService.translate('tuner.myTuner.loadTunersError'),
        });
      },
    });
  }

  validateAffiliateCode(): void {
    if (!this.affiliateInviteCode.trim()) return;
    this.affiliateCodeValidating = true;
    this.affiliateCodeError = '';
    this.validatedAffiliateTuner = null;
    this.tunerService.validateInviteCode(this.affiliateInviteCode.trim(), this.planInformation?.planId ?? undefined).subscribe({
      next: (tuner) => {
        this.affiliateCodeValidating = false;
        this.validatedAffiliateTuner = tuner;
      },
      error: () => {
        this.affiliateCodeValidating = false;
        this.affiliateCodeError = this.translocoService.translate('tuner.myTuner.invalidCode');
      },
    });
  }

  confirmAffiliate(): void {
    if (!this.userId) return;
    const body = this.affiliateMode === 'list'
      ? { tunerId: this.selectedAffiliateTunerId }
      : { inviteCode: this.affiliateInviteCode.trim() };

    const selectedTunerName = this.affiliateMode === 'list'
      ? this.affiliateTuners.find(t => t.userID === this.selectedAffiliateTunerId)?.name ?? ''
      : this.validatedAffiliateTuner?.name ?? '';

    this.affiliateLoading = true;
    this.tunerService.affiliateToTuner(this.userId, body).subscribe({
      next: (response) => {
        this.affiliateLoading = false;
        this.showAffiliatePanel = false;
        this.userTuner = {
          id: response.id,
          tunerID: response.tunerID,
          tunerName: selectedTunerName,
          status: (response.status as 'pending' | 'active' | 'rejected' | 'removed') || 'pending',
          affiliatedAt: new Date().toISOString(),
          acceptedAt: null,
        };
        const successKey = response.status === 'active'
          ? 'tuner.myTuner.affiliateSuccessActive'
          : 'tuner.myTuner.affiliateSuccessPending';
        this.messageService.add({
          key: 'toastAccount',
          severity: 'success',
          summary: this.translocoService.translate(successKey),
        });
      },
      error: (err) => {
        this.affiliateLoading = false;
        const body = err?.error;
        let key = 'tuner.myTuner.affiliateError';
        if (err?.status === 400 && body?.error === 'tuner does not accept your current plan') {
          key = 'tuner.myTuner.affiliateErrorPlanNotAccepted';
        } else if (err?.status === 404 && body?.error === 'user not found') {
          key = 'tuner.myTuner.affiliateErrorUserNotFound';
        } else if (err?.status === 404 && body?.error === 'tuner not found') {
          key = 'tuner.myTuner.affiliateErrorTunerNotFound';
        } else if (err?.status === 409 && body?.status === 'pending') {
          key = 'tuner.myTuner.affiliateErrorPendingExists';
        } else if (err?.status === 409 && body?.status === 'active') {
          key = 'tuner.myTuner.affiliateErrorActiveExists';
        }
        this.messageService.add({
          key: 'toastAccount',
          severity: 'error',
          summary: this.translocoService.translate(key),
        });
      },
    });
  }

  cancelAffiliate(): void {
    this.showAffiliatePanel = false;
  }

  openBillingPortal(): void {
    if (!this.userId) return;
    this.portalLoading = true;
    const returnUrl = `${enviroment.BASE_URL}/profile/subscription`;
    // O portal do Stripe abre em OUTRA guia. A guia é aberta já no clique (síncrono) e só
    // depois recebe a URL: se fosse aberta dentro do callback da API, o bloqueador de pop-up
    // do navegador a barraria. Sem 'noopener' de propósito: com ele window.open devolve null e
    // perderíamos a referência. Se o navegador bloquear mesmo assim, cai para a mesma guia.
    const portalTab = window.open('about:blank', '_blank');
    this.accountService.getSubscriptionPortal(this.userId, returnUrl).subscribe({
      next: ({ portalUrl }) => {
        this.portalLoading = false;
        if (portalTab && !portalTab.closed) {
          portalTab.location.href = portalUrl;
        } else {
          window.location.href = portalUrl;
        }
      },
      error: (err) => {
        this.portalLoading = false;
        portalTab?.close();
        const isNoCustomer = err?.status === 400 &&
          err?.error?.error?.includes('no stripe customer');
        const isNoSubscription = err?.status === 404;
        if (isNoCustomer || isNoSubscription) {
          if (isNoSubscription) {
            this.messageService.add({
              key: 'toastAccount',
              severity: 'info',
              summary: 'Sem assinatura ativa',
              detail: 'Você não possui uma assinatura ativa. Escolha um plano para continuar.',
              life: 5000,
            });
          }
          this.showUpgradeModal = true;
        } else {
          this.messageService.add({
            key: 'toastAccount',
            severity: 'error',
            summary: 'Erro',
            detail: 'Não foi possível abrir o portal. Tente novamente.',
            life: 6000,
          });
        }
      },
    });
  }

  getUserStorageUsed(planInformation: any) {
    if(this.userId!== null){
      this.adminService.getStorageUsed(this.userId).subscribe({
      next: (response) => {
        this.totalStorage = planInformation?.spaceDisk || 0;
        this.usedStorage = response.storage.Total;
        this.storageData = [
          { label: 'admin.accordionTab.storage.logs',      value: response.storage.Logs,          color: '#e67e22', icon: 'pi-file' },
          { label: 'admin.accordionTab.storage.maps',      value: response.storage.Maps,          color: '#3498db', icon: 'pi-map' },
          { label: 'admin.accordionTab.storage.telemetry', value: response.storage.Telemetry ?? 0, color: '#2ecc71', icon: 'pi-chart-line' },
          { label: 'admin.accordionTab.storage.analyses',  value: response.storage.Analyses ?? 0,  color: '#e74c3c', icon: 'pi-chart-bar' },
        ];

        this.displayStorageUsedDialog = true;
        this.chartStorageUsedData = {};
        this.chartStorageUsedOptions = {};
      },
      error: (err) => {
        this.messageService.clear();
        this.messageService.add({
          key: "toastMessage",
          severity: "error",
          summary: "Erro",
          detail: "Falha ao obter armazenamento utilizado!",
        });
      },
    });
    }
  }
}
